// extracted by mini-css-extract-plugin
export default {"userInitialsContainer":"UserInitials__userInitialsContainer___kX4sP"};